/**
 * Agent identity shown in the assistant message header (name + one-line
 * description, next to the "id" avatar).
 *
 * FIXED FOR NOW: every assistant turn is labelled with {@link DEFAULT_AGENT_IDENTITY}.
 * This is a deliberate placeholder until we investigate agent auto-switching and
 * decide how to surface it from a UX standpoint. To make it dynamic later, pass
 * a per-message `agentName` / `agentDescription` into `IdeozMessage` (e.g.
 * resolved from the turn's agent id / a stream header) — the component already
 * accepts those props and only falls back to this default when they're absent.
 */

export interface AgentIdentity {
  name: string;
  description: string;
}

export const DEFAULT_AGENT_IDENTITY: AgentIdentity = {
  name: 'Nexus',
  description: 'Your chief of agents',
};
